import { render } from "./IpAddressesTab.vue?vue&type=template&id=4e8b0e42&scoped=true"
import script from "./IpAddressesTab.vue?vue&type=script&lang=js"
export * from "./IpAddressesTab.vue?vue&type=script&lang=js"

import "./IpAddressesTab.vue?vue&type=style&index=0&id=4e8b0e42&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8b0e42"]])

export default __exports__